<div class="login-container">
  <div class="login-card">
    <h2>Iniciar Sesión</h2>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Email</label>
        <input 
          type="email" 
          id="email" 
          formControlName="email" 
          placeholder="correo@ejemplo.com"
          [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
        >
        <div class="error-message" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
          <span *ngIf="loginForm.get('email')?.errors?.['required']">El email es requerido</span>
          <span *ngIf="loginForm.get('email')?.errors?.['email']">Email inválido</span>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Contraseña</label>
        <input 
          type="password" 
          id="password" 
          formControlName="password"
          [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
        >
        <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          <span *ngIf="loginForm.get('password')?.errors?.['required']">La contraseña es requerida</span>
          <span *ngIf="loginForm.get('password')?.errors?.['minlength']">La contraseña debe tener al menos 6 caracteres</span>
        </div>
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button type="submit" [disabled]="loginForm.invalid || loading">
        <span *ngIf="!loading">Iniciar Sesión</span>
        <span *ngIf="loading">Cargando...</span>
      </button>
    </form>
  </div>
</div>
